<template>
  <div class="skills-page">
    <v-row><h1 class="skills-title mb-4">Skills</h1></v-row>
    <v-row>
      <v-col class="skills-summary">
        <p class="pb-4">
          A highly motivated software engineer and project leader, with expertise in designing efficient applications, optimizing workflows, and driving digital transformation. 
          With 5+ years of experience across software development, database management, and project execution, I specialize in bridging the gap between technical innovation and business efficiency. 
          My proficiency in programming allows me to create scalable solutions, while my background in project engineering has sharpened my ability to manage resources and lead cross-functional teams.
        </p>
        <p class="pb-4">
          As an Application Developer, I built a Vue.js-powered ERP integration, enabling seamless scheduling and improving operational efficiency. 
          I also maintained SQL databases, ensuring robust data analysis and reporting. With experience training over 200 employees in software usage, I bring a strong emphasis on user-centric design and documentation, ensuring adoption at scale.
        </p>
        <p>
          Previously, as a Project Engineer, I developed cost optimization strategies, bid proposals, and HVAC system designs, demonstrating a detail-oriented approach to problem-solving and stakeholder management.
        </p>
        <!-- <p>
          With a blend of technical depth and leadership expertise, I am eager to apply my skills to Microsoft's mission of empowering individuals and businesses through innovative technology.
        </p> -->
      </v-col>
      <v-col>
        <v-row class="skills-container">
          <v-col class="skills-column">
            <div v-for="(skill, index) in leftSkills" :key="index" class="skill-item">
              <img :src="skill.icon" :alt="skill.name" class="skill-icon" />
              <span>{{ skill.name }}</span>
            </div>
          </v-col>
          <v-col class="skills-column">
            <div v-for="(skill, index) in rightSkills" :key="index" class="skill-item">
              <span>{{ skill.name }}</span>
              <img :src="skill.icon" :alt="skill.name" class="skill-icon" />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "SkillsPage",
  data() {
    return {
      codingSkills: [
        { name: "Python", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" },
        { name: "Vue.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg" },
        { name: "JavaScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" },
        { name: "Ruby on Rails", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ruby/ruby-original.svg" },
        { name: "HTML5", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" },
        { name: "CSS3", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" },
        { name: "SQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/azuresqldatabase/azuresqldatabase-original.svg" },
        { name: "C++", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg" },
        { name: "Git", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" },
        { name: "GitHub", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" },
        { name: "Bootstrap", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" },
      ],
    };
  },
  computed: {
    leftSkills() {
      return this.codingSkills.filter((_, index) => index % 2 === 0);
    },
    rightSkills() {
      return this.codingSkills.filter((_, index) => index % 2 !== 0);
    },
  },
};
</script>

<style scoped>
.skills-page {
  text-align: center;
  padding: 20px;
}
.skills-summary, .skills-container, .skills-title {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 15px;
  border-radius: 10px;
  border: 3px solid #ddaf52;
}
.skills-summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 60vh;
  /*font-size: 2.2vh;*/
  font-size: clamp(12px, 1.3vw, 18px);
  margin-left: 2.5vw;
  margin-right: 1.25vw;
}
.skills-container {
  display: flex;
  max-height: 60vh;
  justify-content: space-between;
  margin-left: 1.25vw;
  margin-right: 2.5vw;
}
.skills-title {
  font-size: clamp(5vh, 5.5vw, 6vh);
  margin-left: 2.5vw;
  text-align: left;
}
.skills-column {
  display: flex;
  flex-direction: column;
  width: 50%;
}
.skill-item {
  font-size: clamp(12px, 1.3vw, 18px);
  display: flex;
  align-items: center;
  margin: 10px;
  justify-content: center;
}
.skills-column:first-child .skill-item img {
  margin-right: 10px; /* Left column: Icon before name */
}
.skills-column:last-child .skill-item img {
  margin-left: 10px; /* Right column: Name before icon */
}
.skill-icon {
  width: clamp(32px, 3vw, 48px);
  height: clamp(32px, 3vw, 48px);
}
</style>